import React, { FunctionComponent, useEffect } from 'react';
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary';
import { mapStackTrace } from 'sourcemapped-stacktrace';
import {
  MessageBanner,
  MessageBannerType
} from '@amzn/stencil-react-components/message-banner';
import { useTranslation } from 'react-i18next';
import { logger } from '../util/logger';
import { useLoggerContext } from '../hooks';

const FallbackComponent: FunctionComponent<FallbackProps> = ({ error }) => {
  const { t } = useTranslation();
  const context = useLoggerContext();

  useEffect(() => {
    mapStackTrace(error.stack, (mappedStack) => {
      logger.error('Unexpected Error', error, {
        ...context,
        stackTrace: mappedStack
      });
    });
  }, []);

  return <MessageBanner type={MessageBannerType.Error} titleText='Error'>
    {t('generalErrorMessage')}: {error.message}
    <br />
    {t('generalErrorMessageSuggestion')}
  </MessageBanner>
};

export const ErrorBoundary: FunctionComponent = ({ children }) => (
  <ReactErrorBoundary FallbackComponent={FallbackComponent}>{children}</ReactErrorBoundary>
);
